// extracted by mini-css-extract-plugin
export var acitonButtons = "_hl-0";
export var additionalIcon = "_hl-f";
export var block = "_hl-1";
export var blockContent = "_hl-7";
export var blockDescription = "_hl-8";
export var blockIcon = "_hl-9";
export var blockTitle = "_hl-6";
export var border = "_hl-a";
export var center = "_hl-l";
export var edge = "_hl-b";
export var edgeLabel = "_hl-c";
export var edgePath = "_hl-d";
export var error = "_hl-e";
export var flowchart = "_hl-g";
export var flowchartContent = "_hl-h";
export var highlighted = "_hl-3";
export var hover = "_hl-4";
export var icon = "_hl-i";
export var left = "_hl-m";
export var navButton = "_hl-j";
export var navButtons = "_hl-k";
export var right = "_hl-n";
export var selected = "_hl-2";
export var small = "_hl-5";